(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nosh-founder-collection"] && !Shopify.designMode) return;
  try {
    
/* NOSH — founder 9:16 video controller (Pass 1.1B2)
   Identical, guarded copy of the controller shipped by
   sections/nosh-founder-favourites.liquid. The customElements guard
   means whichever section file is parsed first wins and the second
   copy is a no-op — no duplicate definition, no duplicate observers,
   and no duplicate listeners after a Theme Editor section reload. */
(function () {
  if (window.customElements && customElements.get('nosh-founder-video')) return;

  var MOBILE_QUERY = '(max-width: 749px)';
  var playingNow = new Set();

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  class NoshFounderVideo extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      this.toggleEl = this.querySelector('[data-nosh-fmedia-toggle]');
      if (!this.video || !this.toggleEl) return;

      this.userPaused = false;
      this.handleToggle = this.handleToggle.bind(this);
      this.handlePlay = this.handlePlay.bind(this);
      this.handlePause = this.handlePause.bind(this);
      this.handleIntersect = this.handleIntersect.bind(this);

      this.toggleEl.addEventListener('click', this.handleToggle);
      this.video.addEventListener('play', this.handlePlay);
      this.video.addEventListener('pause', this.handlePause);

      this.video.muted = true;

      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(this.handleIntersect, {
          threshold: [0, 0.35]
        });
        this.observer.observe(this);
      }

      this.setState(false);
    }

    disconnectedCallback() {
      if (this.observer) {
        this.observer.disconnect();
        this.observer = null;
      }
      if (this.toggleEl) {
        this.toggleEl.removeEventListener('click', this.handleToggle);
      }
      if (this.video) {
        this.video.removeEventListener('play', this.handlePlay);
        this.video.removeEventListener('pause', this.handlePause);
        this.video.pause();
      }
      playingNow.delete(this);
    }

    handleIntersect(entries) {
      var entry = entries[entries.length - 1];
      if (!entry) return;

      if (entry.intersectionRatio < 0.35) {
        if (!this.video.paused) this.video.pause();
        return;
      }

      if (this.dataset.autoplay !== 'true') return;
      if (prefersReducedMotion()) return;
      if (this.userPaused) return;

      if (
        window.matchMedia(MOBILE_QUERY).matches &&
        playingNow.size > 0 &&
        !playingNow.has(this)
      ) {
        return;
      }

      this.playVideo();
    }

    playVideo() {
      this.video.muted = true;
      var attempt = this.video.play();
      if (attempt && typeof attempt.catch === 'function') {
        attempt.catch(function () {});
      }
    }

    handleToggle() {
      if (this.video.paused) {
        this.userPaused = false;
        this.playVideo();
      } else {
        this.userPaused = true;
        this.video.pause();
      }
    }

    handlePlay() {
      playingNow.add(this);
      this.setState(true);
    }

    handlePause() {
      playingNow.delete(this);
      this.setState(false);
    }

    setState(isPlaying) {
      this.setAttribute('data-state', isPlaying ? 'playing' : 'paused');
      if (this.toggleEl) {
        this.toggleEl.setAttribute('aria-label', isPlaying ? 'Pause video' : 'Play video');
      }
    }
  }

  customElements.define('nosh-founder-video', NoshFounderVideo);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nosh-founder-favourites"] && !Shopify.designMode) return;
  try {
    
/* NOSH — founder 9:16 video controller (Pass 1.1B2)
   Guarded so the same component can be shipped by more than one
   section file without a duplicate-definition error, and so Theme
   Editor section reloads never register duplicate observers. */
(function () {
  if (window.customElements && customElements.get('nosh-founder-video')) return;

  var MOBILE_QUERY = '(max-width: 749px)';
  var playingNow = new Set();

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  class NoshFounderVideo extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      this.toggleEl = this.querySelector('[data-nosh-fmedia-toggle]');
      if (!this.video || !this.toggleEl) return;

      this.userPaused = false;
      this.handleToggle = this.handleToggle.bind(this);
      this.handlePlay = this.handlePlay.bind(this);
      this.handlePause = this.handlePause.bind(this);
      this.handleIntersect = this.handleIntersect.bind(this);

      this.toggleEl.addEventListener('click', this.handleToggle);
      this.video.addEventListener('play', this.handlePlay);
      this.video.addEventListener('pause', this.handlePause);

      // Audio can never play: enforced here as well as in markup.
      this.video.muted = true;

      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(this.handleIntersect, {
          threshold: [0, 0.35]
        });
        this.observer.observe(this);
      }

      this.setState(false);
    }

    disconnectedCallback() {
      if (this.observer) {
        this.observer.disconnect();
        this.observer = null;
      }
      if (this.toggleEl) {
        this.toggleEl.removeEventListener('click', this.handleToggle);
      }
      if (this.video) {
        this.video.removeEventListener('play', this.handlePlay);
        this.video.removeEventListener('pause', this.handlePause);
        this.video.pause();
      }
      playingNow.delete(this);
    }

    handleIntersect(entries) {
      var entry = entries[entries.length - 1];
      if (!entry) return;

      // Always pause once substantially out of view (saves battery/data).
      if (entry.intersectionRatio < 0.35) {
        if (!this.video.paused) this.video.pause();
        return;
      }

      if (this.dataset.autoplay !== 'true') return;
      if (prefersReducedMotion()) return;
      if (this.userPaused) return;

      // Never autoplay two founder videos at once on mobile.
      if (
        window.matchMedia(MOBILE_QUERY).matches &&
        playingNow.size > 0 &&
        !playingNow.has(this)
      ) {
        return;
      }

      this.playVideo();
    }

    playVideo() {
      this.video.muted = true;
      var attempt = this.video.play();
      if (attempt && typeof attempt.catch === 'function') {
        attempt.catch(function () {
          /* Autoplay refused by the browser — poster stays visible. */
        });
      }
    }

    handleToggle() {
      if (this.video.paused) {
        this.userPaused = false;
        this.playVideo();
      } else {
        this.userPaused = true;
        this.video.pause();
      }
    }

    handlePlay() {
      playingNow.add(this);
      this.setState(true);
    }

    handlePause() {
      playingNow.delete(this);
      this.setState(false);
    }

    setState(isPlaying) {
      this.setAttribute('data-state', isPlaying ? 'playing' : 'paused');
      if (this.toggleEl) {
        this.toggleEl.setAttribute('aria-label', isPlaying ? 'Pause video' : 'Play video');
      }
    }
  }

  customElements.define('nosh-founder-video', NoshFounderVideo);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nosh-founder-rail"] && !Shopify.designMode) return;
  try {
    
/* NOSH — founder rail controls (Pass 1.1B2)
   Progressive enhancement only: the track is a natively scrollable,
   keyboard-reachable list, so the rail is fully usable if this never
   runs. Guarded against duplicate definition and tears its listeners
   down on Theme Editor section reload. */
(function () {
  if (window.customElements && customElements.get('nosh-founder-rail')) return;

  class NoshFounderRail extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-nosh-frail-track]');
      if (!this.track) return;

      var scope = this.closest('.nosh-frail') || document;
      this.prevBtn = scope.querySelector('[data-nosh-frail-prev]');
      this.nextBtn = scope.querySelector('[data-nosh-frail-next]');

      this.handlePrev = this.scrollByPage.bind(this, -1);
      this.handleNext = this.scrollByPage.bind(this, 1);
      this.syncButtons = this.syncButtons.bind(this);

      if (this.prevBtn) this.prevBtn.addEventListener('click', this.handlePrev);
      if (this.nextBtn) this.nextBtn.addEventListener('click', this.handleNext);
      this.track.addEventListener('scroll', this.syncButtons, { passive: true });

      this.syncButtons();
    }

    disconnectedCallback() {
      if (this.prevBtn) this.prevBtn.removeEventListener('click', this.handlePrev);
      if (this.nextBtn) this.nextBtn.removeEventListener('click', this.handleNext);
      if (this.track) this.track.removeEventListener('scroll', this.syncButtons);
    }

    scrollByPage(direction) {
      if (!this.track) return;
      var amount = Math.max(this.track.clientWidth * 0.8, 200);
      this.track.scrollBy({ left: amount * direction, behavior: 'smooth' });
    }

    syncButtons() {
      if (!this.track) return;
      var max = this.track.scrollWidth - this.track.clientWidth;
      var left = this.track.scrollLeft;
      if (this.prevBtn) this.prevBtn.disabled = left <= 2;
      if (this.nextBtn) this.nextBtn.disabled = left >= max - 2;
    }
  }

  customElements.define('nosh-founder-rail', NoshFounderRail);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nosh-our-story-page"] && !Shopify.designMode) return;
  try {
    
/* NOSH — Our Story discovery rail controls (Pass 1.1B3).
   Progressive enhancement: the rail is a natively scrollable,
   keyboard-reachable list and is fully usable if this never runs.
   Guarded against duplicate definition; tears listeners down on
   Theme Editor section reload. */
(function () {
  if (window.customElements && customElements.get('nosh-os-rail')) return;

  class NoshOsRail extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-nosh-os-track]');
      if (!this.track) return;
      var scope = this.closest('.nosh-os__disco') || document;
      this.prevBtn = scope.querySelector('[data-nosh-os-prev]');
      this.nextBtn = scope.querySelector('[data-nosh-os-next]');
      this.handlePrev = this.scrollByPage.bind(this, -1);
      this.handleNext = this.scrollByPage.bind(this, 1);
      this.syncButtons = this.syncButtons.bind(this);
      if (this.prevBtn) this.prevBtn.addEventListener('click', this.handlePrev);
      if (this.nextBtn) this.nextBtn.addEventListener('click', this.handleNext);
      this.track.addEventListener('scroll', this.syncButtons, { passive: true });
      this.syncButtons();
    }
    disconnectedCallback() {
      if (this.prevBtn) this.prevBtn.removeEventListener('click', this.handlePrev);
      if (this.nextBtn) this.nextBtn.removeEventListener('click', this.handleNext);
      if (this.track) this.track.removeEventListener('scroll', this.syncButtons);
    }
    scrollByPage(direction) {
      if (!this.track) return;
      var amount = Math.max(this.track.clientWidth * 0.8, 200);
      this.track.scrollBy({ left: amount * direction, behavior: 'smooth' });
    }
    syncButtons() {
      if (!this.track) return;
      var max = this.track.scrollWidth - this.track.clientWidth;
      var left = this.track.scrollLeft;
      if (this.prevBtn) this.prevBtn.disabled = left <= 2;
      if (this.nextBtn) this.nextBtn.disabled = left >= max - 2;
    }
  }
  customElements.define('nosh-os-rail', NoshOsRail);
})();

/* NOSH — founder 9:16 video controller (Pass 1.1B2)
   Guarded so the same component can be shipped by more than one
   section file without a duplicate-definition error, and so Theme
   Editor section reloads never register duplicate observers. */
(function () {
  if (window.customElements && customElements.get('nosh-founder-video')) return;

  var MOBILE_QUERY = '(max-width: 749px)';
  var playingNow = new Set();

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  class NoshFounderVideo extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      this.toggleEl = this.querySelector('[data-nosh-fmedia-toggle]');
      if (!this.video || !this.toggleEl) return;

      this.userPaused = false;
      this.handleToggle = this.handleToggle.bind(this);
      this.handlePlay = this.handlePlay.bind(this);
      this.handlePause = this.handlePause.bind(this);
      this.handleIntersect = this.handleIntersect.bind(this);

      this.toggleEl.addEventListener('click', this.handleToggle);
      this.video.addEventListener('play', this.handlePlay);
      this.video.addEventListener('pause', this.handlePause);

      // Audio can never play: enforced here as well as in markup.
      this.video.muted = true;

      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(this.handleIntersect, {
          threshold: [0, 0.35]
        });
        this.observer.observe(this);
      }

      this.setState(false);
    }

    disconnectedCallback() {
      if (this.observer) {
        this.observer.disconnect();
        this.observer = null;
      }
      if (this.toggleEl) {
        this.toggleEl.removeEventListener('click', this.handleToggle);
      }
      if (this.video) {
        this.video.removeEventListener('play', this.handlePlay);
        this.video.removeEventListener('pause', this.handlePause);
        this.video.pause();
      }
      playingNow.delete(this);
    }

    handleIntersect(entries) {
      var entry = entries[entries.length - 1];
      if (!entry) return;

      // Always pause once substantially out of view (saves battery/data).
      if (entry.intersectionRatio < 0.35) {
        if (!this.video.paused) this.video.pause();
        return;
      }

      if (this.dataset.autoplay !== 'true') return;
      if (prefersReducedMotion()) return;
      if (this.userPaused) return;

      // Never autoplay two founder videos at once on mobile.
      if (
        window.matchMedia(MOBILE_QUERY).matches &&
        playingNow.size > 0 &&
        !playingNow.has(this)
      ) {
        return;
      }

      this.playVideo();
    }

    playVideo() {
      this.video.muted = true;
      var attempt = this.video.play();
      if (attempt && typeof attempt.catch === 'function') {
        attempt.catch(function () {
          /* Autoplay refused by the browser — poster stays visible. */
        });
      }
    }

    handleToggle() {
      if (this.video.paused) {
        this.userPaused = false;
        this.playVideo();
      } else {
        this.userPaused = true;
        this.video.pause();
      }
    }

    handlePlay() {
      playingNow.add(this);
      this.setState(true);
    }

    handlePause() {
      playingNow.delete(this);
      this.setState(false);
    }

    setState(isPlaying) {
      this.setAttribute('data-state', isPlaying ? 'playing' : 'paused');
      if (this.toggleEl) {
        this.toggleEl.setAttribute('aria-label', isPlaying ? 'Pause video' : 'Play video');
      }
    }
  }

  customElements.define('nosh-founder-video', NoshFounderVideo);
})();

  } catch(e) { console.error(e); }
})();
})();
